import { QRCodeSVG } from "qrcode.react";
import { Text } from "react-native-paper";
import { useAppTheme } from "../useAppTheme";
import Box from "./Box";

type QRCodeProps = {
	url: string;
};

export const ReportQRCode = ({ url }: QRCodeProps) => {
	const currentDate = new Date().toLocaleDateString();
	return (
		<Box>
			<Text>{currentDate}</Text>
			<Box style={{ marginTop: 8 }}>
				<QRCodeSVG value={url} size={60} level="M" includeMargin={false} />
				<Text variant="bodySmall" style={{ marginTop: 4, fontSize: 10 }}>
					Scan to view online
				</Text>
			</Box>
		</Box>
	);
};

type WatermarkProps = {
	appName: string;
};

export const ReportWatermark = ({ appName }: WatermarkProps) => {
	const theme = useAppTheme();

	return (
		<Box
			style={{
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%) rotate(-45deg)",
				opacity: 0.1,
				pointerEvents: "none",
				zIndex: 1,
			}}
		>
			<Text
				variant="displayLarge"
				style={{ fontWeight: "bold", color: theme.colors.onSurface }}
			>
				{appName}
			</Text>
		</Box>
	);
};
